module.exports = new __parcel__URL__("gallery_6.4a0b823c.jpg").toString();